import { hide, show } from './utils.js';

export const initNavigation = () => {
    const spinner = document.querySelector('[data-loading-spinner]');
    if (!spinner) {
        return;
    }

    if (!spinner.hasAttribute('data-keep-spinner')) {
        hide(spinner);
    }

    document.addEventListener('rea:loading', event => {
        if (event.detail) {
            show(spinner);
        } else {
            hide(spinner);
        }
    });

    document.body.addEventListener('click', event => {
        const link = event.target.closest('a[data-loading-link]');
        if (!link || !link.href || link.getAttribute('href')?.startsWith('#')) {
            return;
        }
        show(spinner);
    });
};
